import type { Testimonial } from '../types/content';

// Add only verified testimonials from real buyers. The section stays hidden on the
// published page while this list is empty.
export const testimonials: Testimonial[] = [];
